import React from "react";
import {
  FaBrain,
  FaBookOpen,
  FaVideo,
  FaChartLine,
  FaWaveSquare,
  FaThLarge,
  FaCheckCircle,
  FaAtom,
} from "react-icons/fa";
import { useNavigate } from "react-router-dom";
import { useTranslation } from "react-i18next";

export default function AIAppsGrid() {
  const navigate = useNavigate();
  const { t } = useTranslation();

  const aiApps = [
    {
      label: t("aiApps.questionPaper"),
      icon: FaBrain,
      bg: "#2f7af4",
      path: "/dashboard/teacher/question-paper",
    },
    {
      label: t("aiApps.smartContent"),
      icon: FaChartLine,
      bg: "#f2680a",
      path: "/dashboard/teacher/content-creation",
    },
    {
      label: t("aiApps.studentProgress"),
      icon: FaWaveSquare,
      bg: "#0f9a6e",
      path: "/dashboard/teacher/student-progress",
    },
    {
      label: t("aiApps.teacherLearning"),
      icon: FaBookOpen,
      bg: "#7c3aed",
      path: "/dashboard/teacher/chatbot",
    },
    {
      label: t("aiApps.video"),
      icon: FaVideo,
      bg: "#db2777",
      path: "/dashboard/teacher/video-upload",
    },
    {
      label: t("aiApps.paperEvaluation"),
      icon: FaCheckCircle,
      bg: "#0ea5e9",
      path: "/dashboard/teacher/paper-evaluation",
    },
    {
      label: t("aiApps.virtualLab"),
      icon: FaAtom,
      bg: "#6366f1",
      path: "/dashboard/teacher/virtual-lab",
    },
  ];

  const handleClick = (path) => {
    navigate(path);
  };

  return (
    <section className="mt-12">
      <div className="flex justify-between items-center mb-6 px-2 sm:px-0">
        <h2 className="text-gray-900 font-semibold text-lg flex items-center gap-2">
          <FaThLarge className="text-[#3b56f5]" />
          {t("aiApps.title")}
        </h2>
      </div>

      <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-5 gap-6">
        {aiApps.map((app) => (
          <div
            key={app.label}
            onClick={() => handleClick(app.path)}
            className="rounded-xl shadow-md p-6 flex flex-col items-center gap-3 cursor-pointer relative hover:scale-105 transition-transform"
            style={{ backgroundColor: app.bg }}
          >
            <app.icon className="text-white text-2xl" />
            <p className="text-white font-semibold text-base text-center">
              {app.label}
            </p>
          </div>
        ))}
      </div>
    </section>
  );
}
